import { useEffect, useRef } from 'react';
import axios from 'axios';

interface UseConditionalBlockProps {
  iFrame: any;
  isContentLoading: boolean;
  updateContentSections: () => void;
}

const getConditionalBlocks = (iFrameRef: any) => {
  const iframeDoc = iFrameRef.current?.contentWindow.document;
  if (!iframeDoc) {
    return [];
  }

  const quizQuestions = iframeDoc.querySelectorAll('.conditional_block');
  return quizQuestions as HTMLElement[];
};

const getUrl = (iFrameRef: any, index: number) => {
  const blocks = getConditionalBlocks(iFrameRef);
  if (!blocks[index]) {
    return null;
  }
  const urlEl = (blocks[index] as any).querySelector('#url');
  if (!urlEl) {
    return null;
  }
  const textContentValue = urlEl.textContent;
  if (!textContentValue) {
    return null;
  }
  return JSON.parse(textContentValue);
};

const useConditionalBlock = ({
  iFrame,
  isContentLoading,
  updateContentSections,
}: UseConditionalBlockProps) => {
  const getBlocksInterval = useRef<any>(null);

  useEffect(() => {
    if (getBlocksInterval.current) {
      clearInterval(getBlocksInterval.current);
    }
    const blocks = getConditionalBlocks(iFrame);
    if (isContentLoading && blocks.length === 0) {
      getBlocksInterval.current = setInterval(() => {
        const blocks = getConditionalBlocks(iFrame);
        if (blocks.length) {
          conditionalBlocksInit();
        }
      }, 300);
      return;
    }
    conditionalBlocksInit();
    return () => {
      if (getBlocksInterval.current) {
        clearInterval(getBlocksInterval.current);
      }
    };
  }, [isContentLoading]);

  const conditionalBlocksInit = () => {
    const blocks = getConditionalBlocks(iFrame);
    for (let i = 0; i < blocks.length; i++) {
      const block = blocks[i];
      if (!block) {
        continue;
      }
      const url = getUrl(iFrame, i);
      if (!url) {
        continue;
      }
      axios
        .get(url, {
          headers: {
            'X-CSRFToken': JSON.parse(
              document.getElementById('csrf_token')!.innerHTML,
            ),
          },
        })
        .then((r) => {
          if (r.data.ok) {
            block.style.display = 'block';
          } else {
            block.innerHTML = '';
            updateContentSections();
          }
        });
    }
  };
};

export default useConditionalBlock;
